import * as React from 'react';

export interface CountDisplayProps {
    /**
     * The first item displayed on this page
     */
    start: number;
    /**
     * The last item displayed on this page
     */
    end: number;
    /**
     * The total number of (filtered) items
     */
    total: number;
}

/**
 * This is the pagination info component
 * @param props Component props
 */
export function CountDisplay(props: CountDisplayProps) {
    return (
        <div className="dataTables_info pull-right">
            <span>
                Showing {props.start} to {props.end} of {props.total} entries
            </span>
        </div>
    );
}
